import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UploadService } from "src/app/services/upload.service";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-vendor-management",
  templateUrl: "./vendor-management.component.html",
  styleUrls: ["./vendor-management.component.css"],
})
export class VendorManagementComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  token = this.ls.get("token");
  alphaPattern = "[a-zA-Z .,]*";

  VendorForm: FormGroup;
  otp: string;
  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  entryFields: boolean = false;
  createNew: boolean = true;
  submitted = false;
  manualUpdate = true;
  swal: any;
  enable = true;
  total_count = 0;
  admcreate: any;
  vendList: any[] = [];
  getvend: any;
  editvend: any;
  is_active: any;
  create_active: any;
  deletevend: any;
  editstatus: any;
  admupdate: any;
  admstatusupdate: any;
  editid: any;
  pass: any;
  department: any;
  dept: any;
  vend: any;
  vendor: any;
  isactiveswitch: any;
  editbut: boolean;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  selectedFiles: any;
  selected_file_view: any;
  logosrc: any;
  logo: any;
  // preview_image: any;
  pre_logo = [];
  email_address: any;
  mobile_number: any;
  username: any;
  count: any;
  total: number;
  p: number;
  pagedItems: any[];
  token_val: any;
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any[];
  settingVend: any;
  settingUpdateStatus: any;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private upload: UploadService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      uname: [""],
      email: [""],
      mobile: [""],
    });

    this.VendorForm = this.fb.group({
      id: [""],
      name: ["", [Validators.required]],
      logo: [""],
      username: ["", [Validators.required]],
      email_address: ["", [Validators.required]],
      mobile_number: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],

      is_active: [""],
      allowed_student: [
        "",
        [Validators.required, Validators.min(1), Validators.max(100000)],
      ],
      allowed_professor: [
        "",
        [Validators.required, Validators.min(1), Validators.max(10000)],
      ],
      allowed_classroom: [
        "",
        [Validators.required, Validators.min(1), Validators.max(1000)],
      ],
      vendor_type_id: ["", [Validators.required]],
    });
    this.page = 1;
    await this.getDepartment();
    await this.getVendor();
    await this.getPage(this.page, true);
  }

  get forms1() {
    return this.searchForm.controls;
  }

  async getPage(page: number, disableCall: boolean = false) {
    this.page = page;
    if(!disableCall){
      await this.getVendor();
    }
    const res = await this.serverCall(this.vendList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.VendorForm.controls;
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.vendor = await this.globalService.get(
      "vendor/type/list/dropdown",
      filter,
      true
    );

    this.vend = this.vendor["content"];
    this.spinner.hide();
  }
  switch(e) {
    this.isactiveswitch = e;
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.selected_file_view = this.selectedFiles.item(0).name;
  }

  async createVendor(form: FormGroup) {
    this.submitted = true;

    let file;
    let files;
    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);
      if (file) {
        if (
          file.type !== "image/jpeg" &&
          file.type !== "image/png" &&
          file.type &&
          "image/jpg" &&
          file.type &&
          "image/PNG" &&
          file.type !== "image/JPG" &&
          file.type &&
          "image/JPEG"
        ) {
          Swal.fire(
            "warning!",
            "Company Logo should allowed Jpg,Jpeg and Png format only",
            "warning"
          );
          return false;
        } else if (file.size > 1048576) {
          Swal.fire(
            "warning!",
            "Please upload Company Logo size should below 1 MB ",
            "warning"
          );
          return false;
        } else if (
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "image/jpg" ||
          file.type == "image/PNG" ||
          file.type == "image/JPG" ||
          file.type == "image/JPEG"
        ) {
          files = new Date().getTime() + "_Logo_" + file.type;
          // this.upload.uploadfile(files, "image", file.size, file);
        }
      }
    }

    if (this.VendorForm.invalid) {
      return;
    }

    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      name: form.value.name,
      logo: files,
      username: form.value.username,
      email: form.value.email_address,
      mobile_number: form.value.mobile_number,

      allowed_student: form.value.allowed_student,
      allowed_professor: form.value.allowed_professor,
      allowed_classroom: form.value.allowed_classroom,
      vendor_type_id: form.value.vendor_type_id,
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",

      role_id: this.storageService.getRole(),
    };

    this.admcreate = await this.globalService.create(
      "vendor/create",
      inputData
    );

    if (this.admcreate["status"] === 200) {
      Swal.fire("Success!", this.admcreate["message"], "success");
      this.pageshow = true;
      this.getVendor();
      this.reset();
      this.cancelFields();
    }
    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }

  Filter(email_address, mobile_number, username) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.username != undefined && this.username != "") {
      this.chiparray.push("Uname :" + " " + this.username);
    }
    if (this.email_address != undefined && this.email_address != "") {
      this.chiparray.push("Email :" + " " + this.email_address);
    }
    if (this.mobile_number != undefined && this.mobile_number != "") {
      this.chiparray.push("Mobile :" + " " + this.mobile_number);
    }

    this.email_address = email_address;
    this.mobile_number = mobile_number;
    this.username = username;

    this.pageshow = true;
    this.page = 1;
    this.getVendor();
  }
  res() {
    this.filtervalues = false;
    this.chiparray = [];
    this.username = null;
    this.email_address = null;
    this.mobile_number = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.getVendor();
  }

  async getVendor() {
    this.spinner.show();
    if (this.page === 1) {
      this.vendList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      role_id: this.storageService.getRole(),
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
    };

    this.getvend = await this.globalService.get("vendor/list", filter);
    this.spinner.hide();
    if (this.getvend["status"] === 200) {
      this.total_count = this.getvend["content"].count;
      if (this.getvend["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
      this.token_val = this.ls.get("token");
      this.vendList = this.getvend["content"]["rows"];

      for (let i = 0; i < this.getvend["content"]["rows"].length; i++) {
        this.logo = this.getvend["content"]["rows"][i].logo;

        // this.preview_image = this.upload.generateAwsFileUrl(this.logo);
        // this.pre_logo.push(this.preview_image.s3_url);
        // this.vendList[i]["logo"] = this.preview_image.s3_url;
      }
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.spinner.hide();
      this.showLoadMore = true;
    }

    (error) => {
      this.vendList = [];
      this.spinner.hide();
      this.showLoadMore = true;
    };

    this.spinner.hide();
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.VendorForm.reset();
    this.submitted = false;
  }

  editVendor(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: this.storageService.getRole(),
          id: id,
        };
        this.editvend = await this.globalService.get("vendor/get", filter);
        let comp_details = this.editvend["content"];
        if (this.editvend["status"] === 200) {
          this.VendorForm.controls["id"].setValue(comp_details.id);
          this.VendorForm.controls["name"].setValue(comp_details.name);

          this.VendorForm.controls["username"].setValue(
            comp_details.vendor_admin.username
          );
          this.VendorForm.controls["mobile_number"].setValue(
            comp_details.vendor_admin.mobile_number
          );
          this.VendorForm.controls["email_address"].setValue(
            comp_details.vendor_admin.email_address
          );
          this.VendorForm.controls["allowed_student"].setValue(
            comp_details.allowed_student
          );
          this.VendorForm.controls["allowed_professor"].setValue(
            comp_details.allowed_professor
          );
          this.VendorForm.controls["allowed_classroom"].setValue(
            comp_details.allowed_classroom
          );
          this.VendorForm.controls["vendor_type_id"].setValue(
            comp_details.vendor_type_id
          );
          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
          this.logo = comp_details.logo;
        }
      }
      this.spinner.hide();
    });
  }

  reset() {
    this.submitted = false;
    this.VendorForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
    this.spinner.hide();
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getVendor();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getVendor();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getVendor();
  }

  VendorStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.admstatusupdate = await this.globalService.update(
          "vendor/update/status",
          inputData
        );
        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.getVendor();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getVendor();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getVendor();
      }
    });
    this.spinner.hide();
  }

  async updateVendor(form: FormGroup) {
    this.submitted = true;

    if (this.VendorForm.invalid) {
      return;
    }
    this.spinner.show();

    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      is_active: this.editstatus === true ? "1" : "0",
      user_id: this.ls.get("createdBy"),
      name: form.value.name,
      username: form.value.username,
      email: form.value.email_address,
      mobile_number: form.value.mobile_number,
      allowed_student: form.value.allowed_student,
      allowed_professor: form.value.allowed_professor,
      allowed_classroom: form.value.allowed_classroom,
      vendor_type_id: form.value.vendor_type_id,

      role_id: this.storageService.getRole(),
    };

    this.admupdate = await this.globalService.update(
      "vendor/update",
      inputData
    );

    if (this.admupdate["status"] === 200) {
      Swal.fire("Success!", this.admupdate["message"], "success");
      this.spinner.show();
      this.pageshow = true;
      this.getVendor();
      this.editbut = false;
      this.reset();
    }

    this.spinner.hide();
    this.cancelFields();
  }

  async deleteVendor(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          role_id: this.storageService.getRole(),
        };
        this.deletevend = await this.globalService.delete(
          "vendor/delete",
          filter
        );
        if (this.deletevend["status"] === 200) {
          this.spinner.hide();
          this.vendList = [];
          Swal.fire("Success!", this.deletevend["message"], "success");
          this.pageshow = true;
          this.getVendor();
        }
      }
    });
    this.spinner.hide();
  }

  formReset() {
    this.VendorForm.reset();
    this.editbut = false;
  }

  async settingVendor(content, Id) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      id: Id,
    };
    this.settingVend = await this.globalService.get(
      "vendor/get/settings",
      filter
    );
    this.spinner.hide();
    this.modalService.open(content, { centered: true, size: "md" });
  }

  settingSwitch(ev, value) {
    if (ev) {
      this.settingVend.content[value] = 1;
    } else {
      this.settingVend.content[value] = 0;
    }
  }

  async settingUpdate() {
    this.spinner.show();
    let data = this.settingVend.content;
    let inputData = {
      user_id: this.ls.get("createdBy"),
      id: data.id,
      web_permission: data.web_permission,
      mobile_permission: data.mobile_permission,
      report_permission: data.report_permission,
      video_edit_permission: data.video_edit_permission,
      live_class_permission: data.live_class_permission,
      is_student_search_all_video: data.is_student_search_all_video,
      login_otp: data.login_otp,
    };

    this.settingUpdateStatus = await this.globalService.update(
      "vendor/update/settings",
      inputData
    );
    if (this.settingUpdateStatus["status"] === 200) {
      this.vendList = [];
      Swal.fire("Success!", this.settingUpdateStatus["message"], "success");
      this.modalService.dismissAll();
      this.pageshow = true;
      this.getVendor();
    }
    this.spinner.hide();
  }
  paginationCount(value) {
    this.page = 1;
    this.page_size = value;
    this.getVendor();
  }
  openPopup() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.submitted = false;
  }
  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.VendorForm.reset();
    this.createNew = true;
    this.entryFields = false;
  }
}
